<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.39261 1.08545C3.51418 0.973862 3.70364 0.97125 3.82773 1.08003C4.02379 1.2519 4.31042 1.48439 4.5142 1.56879C4.70378 1.64732 5.00836 1.67503 5.23987 1.6842C5.41275 1.69105 5.5551 1.83329 5.56107 2.0062C5.56947 2.24957 5.59659 2.57517 5.67736 2.77015C5.75858 2.96625 5.97416 3.2236 6.14292 3.40711C6.26084 3.53533 6.25753 3.73819 6.13639 3.86337C5.96809 4.03727 5.75627 4.27968 5.67736 4.4702C5.59668 4.66497 5.56979 5.01099 5.56142 5.26697C5.55572 5.44128 5.41047 5.58352 5.23613 5.58824C4.99306 5.59482 4.66698 5.62123 4.45722 5.70812C4.24068 5.79781 3.9866 6.01884 3.8131 6.18674C3.69549 6.30056 3.5085 6.31248 3.3832 6.20718C3.1556 6.01591 2.82471 5.74464 2.73654 5.70812C2.54522 5.62887 2.2203 5.60153 1.97668 5.59266C1.80332 5.58634 1.66135 5.44292 1.65657 5.26951C1.64964 5.01777 1.62339 4.67628 1.53803 4.4702C1.4571 4.27481 1.25794 4.04401 1.0943 3.87516C0.968247 3.7451 0.968136 3.53182 1.09644 3.40399C1.28281 3.21832 1.51878 2.95959 1.59725 2.77015C1.67341 2.58628 1.68297 2.27024 1.67656 2.02687C1.6718 1.84626 1.81616 1.69018 1.99667 1.68276C2.23907 1.6728 2.55322 1.64473 2.73654 1.56879C2.9329 1.48745 3.20502 1.25764 3.39261 1.08545Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M4.53811 3L3.48066 4.15359L3 3.62923"
      stroke="white"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
